import styled from '@emotion/styled';
import { SxProps, Theme } from '@mui/material';

/**
 * 칩 팝오버(양식/결재자/상태/등록기간/필터 더보기)와 공유하는 트리거 스타일.
 * 시안: 미선택 = 흰 배경 + 회색 테두리, 선택 = 회색 배경. 열림(포커스) = 검정 테두리.
 * 높이 36px 로 검색 입력과 동일하게 맞춘다. (PORTAL-12883)
 */
export const ChipButton = styled.button<{ selected: boolean; open: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 4px 8px;
  border-radius: 8px;
  background: ${({ selected }) => (selected ? 'var(--dk-bg-muted, #f3f5f6)' : 'var(--dk-bg, #ffffff)')};
  border: 1px solid
    ${({ open, selected }) =>
      open ? 'black' : selected ? '#f3f5f6' : '#e7e9ec'};
  flex-shrink: 0;
`;

/** 칩 필터명 라벨(양식/결재자/등록기간 등) — 시안: 항상 gray_7 */
export const ChipLabel = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text-strong, #5f636b);
`;

export const ChipDivider = styled.span`
  width: 1px;
  height: 12px;
  background: var(--dk-bg-strong, #d4d7db);
`;

/** 선택값 pill 묶음 — 시안: pill 끼리 gap 4px */
export const ChipValues = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

/**
 * 선택값 pill — 시안: 흰 배경 + gray_3 테두리 + 파랑 텍스트, radius 4. 값이 잘리지 않게 폭 제한 없음.
 * 높이는 테두리 포함 28px (border inset — PORTAL-12883)
 */
export const ChipValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  box-sizing: border-box;
  padding: 4px 8px;
  background: var(--dk-bg, #ffffff);
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 4px;
  color: var(--dk-accent, #0066cc);
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
`;

/** 나머지 선택 개수(+N) — ChipValue 와 동일한 pill 형태 */
export const ChipExtra = styled(ChipValue)``;

export const Chevron = styled.span<{ open: boolean }>`
  display: inline-flex;
  color: var(--dk-text, black);
  transition: transform 0.15s ease;
  transform: rotate(${({ open }) => (open ? '180deg' : '0deg')});
`;

/** 팝오버 종이(패널) 공통 스타일 — Figma: 흰 배경, 그림자, radius 8, 1px black. 내용은 패널 폭을 꽉 채움(패딩 0) */
export const popoverPaperSx: SxProps<Theme> = {
  marginTop: '8px',
  borderRadius: '8px',
  border: '1px solid black',
  boxShadow: '0px 16px 32px rgba(0, 0, 0, 0.08)',
  padding: 0,
  overflow: 'hidden',
};

/** 필터바 1행: 검색 + 칩들 (가로, 넘치면 wrap) */
export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

/** 필터바 2행: 전체해제 / 내 필터로 저장 */
export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

/** 전체해제 — 시안: 파랑 텍스트 + 새로고침 아이콘(밑줄 없음, 내 필터로 저장과 동일 Text button). DocumentRightFilters 의 검정 AllClearButton 과 별개 */
export const ClearAllButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--dk-accent, #0066cc);
  font-size: 14px;
  line-height: 20px;
`;

/** 필터 더보기 팝오버 안 각 필터 섹션 라벨 */
export const MoreSectionTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--dk-text-primary, #34383d);
  margin-bottom: 8px;
`;

/** 필터 더보기 트리거의 선택 개수 뱃지 */
export const CountBadge = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-accent, #0066cc);
`;
